<template>
  <div class="c-personal-wrapper">
    <!-- filter -->
    <work-filter @on-change="filterData" />
    <div class="c-contorl-btn">
      <Button icon="md-download" :style="{ marginLeft: 0 }" @click="downData">数据导出</Button>
      <div class="right-btns">
        <div class="show-empty-switch">
          <span>仅显示有数据素材</span>
          <i-Switch v-model="hasRecord" :true-value="1" :false-value="0" />
        </div>

        <DateRangePicker v-model="datetime" @change="onDateChange" :clearable="false" style="width: 220px"></DateRangePicker>
      </div>
    </div>
    <!-- table  -->
    <Viewport v-model="tableHeight">
      <el-table class="common-el-table-styles" border :data="tableData" :height="tableHeight - 1" v-loading="loading">
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="{ row }">
            <span v-if="['newRoleRateAndroid', 'newRoleRateIOS'].includes(col.key)">{{ row[col.key] | toPercent }}</span>
            <span v-else-if="col.key === 'source'">
              {{ row[col.key] ? SOURCE_TYPES.find((s) => s.value === row[col.key]).label : '-' }}</span
            >
            <span
              v-else-if="
                ['payBackCalcStandardAndroid', 'payBackCalcValueAndroid', 'payBackCalcStandardIOS', 'payBackCalcValueIOS'].includes(col.key)
              "
              >{{ row[col.key] | formatNull }}</span
            >
            <span v-else-if="!['imageId', 'imageName', 'designerName', 'labelNames', 'typeLabelNames', 'uploadTime'].includes(col.key)">{{
              row[col.key] | toThousands
            }}</span>
            <span v-else-if="col.key === 'createTime'">{{ row[col.key] | datetimeToSec }}</span>
            <span v-else-if="col.key === 'upTime'">{{ row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>
  </div>
</template>
<script>
import moment from 'moment'
import { HOST_API } from '@/api/config'
import { isArray } from '@/common/js/utils'
import { toPercent } from '@/common/js/filters'
import tableMixin from '../designerkpi/mixin_table'
import tableColumns from '../data/worker_columns'
import WorkFilter from './components/work-filter'
import DateRangePicker from '@/components/date-range-picker'
import { SOURCE_TYPES } from '@/views/material/tags/const'

import { getWorkPage } from '@/api/team.model'

const now = moment().subtract(1, 'days').format('YYYY-MM-DD')
export default {
  name: 'Works',
  mixins: [tableMixin],
  components: { WorkFilter, DateRangePicker },
  data() {
    return {
      params: {},
      datetime: [now, now],
      loading: null,
      tableHeight: 330,
      tableData: [],
      tableColumns: [],
      hasRecord: 1 // 是否显示有数据素材
    }
  },
  computed: {
    SOURCE_TYPES() {
      return SOURCE_TYPES
    }
  },
  methods: {
    downData() {
      let url = `${HOST_API}/api/ptom/designer/exportImageData`
      url += `?sessionid=${this.$store.state.token}`
      url += `&beginTime=${this.params.beginTime}`
      url += `&endTime=${this.params.endTime}`
      url += `&status=${this.hasRecord}`
      this.params.uploadBeginTime && (url += `&uploadBeginTime=${this.params.uploadBeginTime}`)
      this.params.uploadEndTime && (url += `&uploadEndTime=${this.params.uploadEndTime}`)
      this.params.dataGroupId > 0 && (url += `&dataGroupId=${this.params.dataGroupId}`)
      this.params.dataGameId > 0 && (url += `&dataGameId=${this.params.dataGameId}`)
      this.params.gameGroupId > 0 && (url += `&gameGroupId=${this.params.gameGroupId}`)
      this.params.gameId > 0 && (url += `&gameId=${this.params.gameId}`)
      this.params.designerId > 0 && (url += `&designerId=${this.params.designerId}`)
      this.params.labelIdsStr && (url += `&labelIdsStr=${this.params.labelIdsStr}`)
      this.params.typeLabelId && (url += `&typeLabelId=${this.params.typeLabelId}`)
      this.params.source && (url += `&source=${this.params.source}`)
      this.params.planName && (url += `&planName=${this.params.planName}`)
      this.params.imageName && (url += `&imageName=${this.params.imageName}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    },
    onDateChange() {
      this.pageIndex = 1
      this.getData()
    },
    getData(filter) {
      let params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        status: this.hasRecord
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getWorkPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = tableColumns
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    }
  },
  created() {
    this.getData()
  },
  watch: {
    hasRecord() {
      this.pageIndex = 1
      this.getData()
    }
  },
  filters: {
    formatNull(cell) {
      return cell === null ? '-' : typeof cell === 'number' ? toPercent(cell) : cell
    }
  }
}
</script>
<style lang="scss" scoped>
.c-personal-wrapper {
  .c-contorl-btn {
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    justify-content: space-between;

    .right-btns {
      display: flex;
    }

    .show-empty-switch {
      display: flex;
      align-items: center;
      margin-right: 10px;
      span {
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
